<template>
    <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
        <div class="header-bg">
            <div class="content-nav-bar">
                <van-nav-bar title="设置量化条件">
                    <template #left>
                        <van-icon name="arrow-left" size="18" @click="goBack" />
                    </template>
                </van-nav-bar>
            </div>
            <div class="content" :style="`height:calc(100vh - ${contentNavBar}px)`">
                <div class="yz-list">
                    <FactorArgumentsModal></FactorArgumentsModal>
                    <!-- <h2 class="h2">因子组合池(共{{ checkedYzList.length }}只因子)</h2> -->

                    <!-- 如果是原生app带参数调过来的走这里逻辑 -->

                    <!-- <ul
            class="yz-ul"
            v-if="
              (checkedYzList.length && $route.query.userid) || $route.query.collection_type == 4
            "
          >
            <li v-for="item in checkedYzList" :key="item.ID">
              <div class="a-left">
                <div style="display: flex">
                  {{ item.FactorName }}
                  <span class="gs" v-if="item.yzType == 4">公式</span>
                  <span class="gs" v-if="item.yzType == 6">自然</span>
                  <span class="gs" v-if="item.yzType == 2">拖拽</span>
                </div>
              </div>
            </li>
          </ul>

          <ul
            class="yz-ul"
            v-if="checkedYzList.length && !$route.query.userid && $route.query.collection_type != 4"
          >
            <li v-for="item in checkedYzList" :key="item.ID">
              <div class="a-left">
                <div style="display: flex">
                  {{ item.FactorName }}
                  <span class="gs" v-if="item.yzType == 4">公式</span>
                  <span class="gs" v-if="item.yzType == 6">自然</span>
                </div>

                <p class="XiFenZhongLei">{{ item.XiFenZhongLei || item.SubClassName }}</p>
              </div>

              <div class="a-right">
                <div
                  v-if="item.yzType == 0"
                  style="display: flex; justify-content: space-between; width: 70%"
                >
                  <p :class="[judgeColor(item.RiZhangFu)]">
                    {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                  </p>
                  <p class="zhi">{{ item.XinHaoShuLiang || 0 }}只</p>
                </div>

                <div v-else></div>

                <img src="@/assets/image/sc.png" alt="" @click="delYz(item)" />
              </div>
            </li>
          </ul> -->

                    <!-- <van-empty
            description="请添加因子"
            :image="require('@/assets/image/notData.png')"
            v-if="!checkedYzList.length"
          /> -->
                </div>

                <div class="condition">
                    <h2 class="h2" style="margin-top: 16px">设置基础条件</h2>

                    <div class="condition-list">
                        <span class="label">回测周期</span>
                        <div class="date-time" v-if="!publicHcID || (Obj.startDate && Obj.endDate)">
                            <p @click="beginshow = true">{{ newBeginCurrentDate }}</p>
                            <p>至</p>
                            <p @click="endshow = true">{{ newEndCurrentDate }}</p>
                        </div>
                    </div>

                    <div class="condition-list">
                        <span class="label">初始化资金</span>
                        <div class="c-l-right">
                            <van-field v-model="capital" type="digit" label="" />
                            <span class="unit">元</span>
                        </div>
                    </div>

                    <div class="condition-list">
                        <span class="label">
                            {{ $route.query.yzType == 'ETF' ? '持仓上限' : '持股上限' }}
                        </span>
                        <div class="c-l-right">
                            <p class="imitation-select" @click="showAstrict = true">
                                {{ astrictValue }}
                                <van-icon name="arrow-down" class="arrow-down" />
                            </p>
                        </div>

                        <van-action-sheet v-model="showAstrict">
                            <van-picker
                                title="选择持股上限"
                                show-toolbar
                                :columns="columnsAstrict"
                                @confirm="onConfirmAstrict"
                                @cancel="onCancelAstrict"
                                :default-index="sx_defaultIndex"
                            />
                        </van-action-sheet>
                    </div>

                    <div>
                        <p class="second-level">持股周期</p>

                        <div class="period" style="border: none; padding-bottom: 0">
                            <van-row gutter="12">
                                <van-col span="6" v-for="(item, index) in periodArr" :key="index">
                                    <div
                                        :class="{ active: item.checked }"
                                        @click="handleClickCol(index)"
                                    >
                                        {{ item.name }}
                                    </div>
                                </van-col>
                            </van-row>
                        </div>

                        <div class="period-value" v-if="isCustomSelected">
                            <van-field
                                v-model="value"
                                placeholder="输入天数，以逗号分隔，范围为2-99"
                                @blur="handleBlur"
                            />

                            <p v-if="isShowCgzqText" class="isShowCgzqText">
                                输入天数范围应该在2-99之间
                            </p>
                        </div>
                    </div>

                    <p
                        class="division"
                        :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
                    ></p>

                    <h2 class="h2">设置买入条件</h2>
                    <div class="condition-list">
                        <span class="label">买入时机</span>
                        <div class="c-l-right">
                            <p class="mrsj-button">次日开盘买入</p>
                        </div>
                    </div>

                    <div class="condition-list">
                        <span class="label">单日买入数量</span>
                        <div class="c-l-right">
                            <p class="imitation-select" @click="showNum = true">
                                {{ numValue }}
                                <van-icon name="arrow-down" class="arrow-down" />
                            </p>
                        </div>

                        <van-action-sheet v-model="showNum">
                            <van-picker
                                title="选择单日买入数量"
                                show-toolbar
                                :columns="columnsNum"
                                @confirm="onConfirmNum"
                                @cancel="onCancelNum"
                                :default-index="mrsl_defaultIndex"
                            />
                        </van-action-sheet>
                    </div>

                    <div class="condition-list">
                        <span class="label">买入顺序</span>
                        <div class="c-l-right">
                            <p class="imitation-select" @click="showLeftOrder = true">
                                {{ leftOrderValue.label }}
                                <van-icon name="arrow-down" class="arrow-down" />
                            </p>
                            <span style="margin: 0 5px" class="ji">及</span>
                            <p class="imitation-select" @click="showRightOrder = true">
                                {{ rightOrderValue.label }}
                                <van-icon name="arrow-down" class="arrow-down" />
                            </p>
                        </div>

                        <van-action-sheet v-model="showLeftOrder">
                            <van-picker
                                title="选择买入顺序"
                                show-toolbar
                                :columns="columnsLeftOrder"
                                @confirm="onConfirmLeftOrder"
                                @cancel="onCancelLeftOrder"
                                :default-index="mrsxLeft_defaultIndex"
                            >
                                <template #option="option">
                                    {{ option.label }}
                                </template>
                            </van-picker>
                        </van-action-sheet>

                        <van-action-sheet v-model="showRightOrder">
                            <van-picker
                                title="选择买入顺序"
                                show-toolbar
                                :columns="columnsRightOrder"
                                @confirm="onConfirmRightOrder"
                                @cancel="onCancelRightOrder"
                                :default-index="mrsxRight_defaultIndex"
                            >
                                <template #option="option">
                                    {{ option.label }}
                                </template>
                            </van-picker>
                        </van-action-sheet>
                    </div>

                    <p
                        class="division"
                        :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
                    ></p>

                    <h2 class="h2">设置风控条件</h2>

                    <div class="condition-list">
                        <span class="label">风控模型</span>
                        <van-radio-group v-model="dpfkmb" direction="horizontal">
                            <van-radio :name="0">普通交易规则</van-radio>
                            <van-radio :name="1" v-if="$route.query.yzType == 'A'"
                                >大盘择时交易</van-radio
                            >
                        </van-radio-group>
                    </div>

                    <div v-if="dpfkmb == 0">
                        <div class="condition-list">
                            <span class="label">仓位控制</span>
                            <div class="c-l-right">
                                <p class="mrsj-button">满仓</p>
                            </div>
                        </div>

                        <div class="condition-list">
                            <span class="label">策略止盈</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≥</span>
                                <div style="position: relative">
                                    <van-field
                                        v-model="zhiying"
                                        type="digit"
                                        label=""
                                        @blur="zhiying <= 0 ? (zhiying = 9) : zhiying"
                                    />
                                    <span class="unit">%</span>
                                </div>
                                <span class="text" style="margin-left: 6px">时坚定持有</span>
                            </div>
                        </div>
                        <div class="condition-list">
                            <span class="label"></span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">直到最高收益回落</span>
                                <van-field
                                    v-model="huiluo"
                                    type="digit"
                                    label=""
                                    @blur="huiluo <= 0 ? (huiluo = 1) : huiluo"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>

                        <div class="condition-list" style="border: none">
                            <span class="label">策略止损</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≤ -</span>
                                <van-field
                                    v-model="zhisun"
                                    type="digit"
                                    label=""
                                    @blur="zhisun <= 0 ? (zhisun = 5) : zhisun"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="dpfkmb == 1">
                        <div class="condition-list">
                            <span class="label" @click="viewIntroduction = true"
                                >大盘风控模版<i style="margin-left: 4px"
                                    ><van-icon name="question-o" color="#CFCFCF" /></i
                            ></span>

                            <div class="c-l-right">
                                <p
                                    class="imitation-select"
                                    @click="fkmbPickerType = true"
                                    style="width: 100%"
                                >
                                    {{ dpfkmbData.text }}
                                    <van-icon name="arrow-down" class="arrow-down" />
                                </p>
                            </div>
                        </div>

                        <div class="fk_title"><i></i>强势市场</div>

                        <div class="condition-list">
                            <span class="label">仓位控制</span>

                            <div class="c-l-right">
                                <p
                                    class="imitation-select"
                                    @click="qs_CwkzPickerType = true"
                                    style="width: 100%"
                                >
                                    {{ qs_Data.text }}
                                    <van-icon name="arrow-down" class="arrow-down" />
                                </p>
                            </div>
                        </div>

                        <div class="condition-list">
                            <span class="label">策略止盈</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≥</span>
                                <div style="position: relative">
                                    <van-field
                                        v-model="zhiying_qs"
                                        type="digit"
                                        label=""
                                        @blur="zhiying_qs <= 0 ? (zhiying_qs = 14) : zhiying_qs"
                                    />
                                    <span class="unit">%</span>
                                </div>
                                <span class="text" style="margin-left: 6px">时坚定持有</span>
                            </div>
                        </div>
                        <div class="condition-list">
                            <span class="label"></span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">直到最高收益回落</span>
                                <van-field
                                    v-model="huiluo_qs"
                                    type="digit"
                                    label=""
                                    @blur="huiluo_qs <= 0 ? (huiluo_qs = 1) : huiluo_qs"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>

                        <div class="condition-list" style="border: none">
                            <span class="label">策略止损</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≤ -</span>
                                <van-field
                                    v-model="zhisun_qs"
                                    type="digit"
                                    label=""
                                    @blur="zhisun_qs <= 0 ? (zhisun_qs = 7) : zhisun_qs"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>

                        <div class="fk_title"><i></i>弱势市场</div>

                        <div class="condition-list">
                            <span class="label">仓位控制</span>

                            <div class="c-l-right">
                                <p
                                    class="imitation-select"
                                    @click="rs_CwkzPickerType = true"
                                    style="width: 100%"
                                >
                                    {{ rs_Data.text }}
                                    <van-icon name="arrow-down" class="arrow-down" />
                                </p>
                            </div>
                        </div>

                        <div class="condition-list">
                            <span class="label">策略止盈</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≥</span>
                                <div style="position: relative">
                                    <van-field
                                        v-model="zhiying_rs"
                                        type="digit"
                                        label=""
                                        @blur="zhiying_rs <= 0 ? (zhiying_rs = 5) : zhiying_rs"
                                    />
                                    <span class="unit">%</span>
                                </div>
                                <span class="text" style="margin-left: 6px">时坚定持有</span>
                            </div>
                        </div>
                        <div class="condition-list">
                            <span class="label"></span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">直到最高收益回落</span>
                                <van-field
                                    v-model="huiluo_rs"
                                    type="digit"
                                    label=""
                                    @blur="huiluo_rs <= 0 ? (huiluo_rs = 1) : huiluo_rs"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>

                        <div class="condition-list" style="border: none">
                            <span class="label">策略止损</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≤ -</span>
                                <van-field
                                    v-model="zhisun_rs"
                                    type="digit"
                                    label=""
                                    @blur="zhisun_rs <= 0 ? (zhisun_rs = 3) : zhisun_rs"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>

                        <div class="fk_title"><i></i>震荡市场</div>

                        <div class="condition-list">
                            <span class="label">仓位控制</span>

                            <div class="c-l-right">
                                <p
                                    class="imitation-select"
                                    @click="zd_CwkzPickerType = true"
                                    style="width: 100%"
                                >
                                    {{ zd_Data.text }}
                                    <van-icon name="arrow-down" class="arrow-down" />
                                </p>
                            </div>
                        </div>

                        <div class="condition-list">
                            <span class="label">策略止盈</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≥</span>
                                <div style="position: relative">
                                    <van-field
                                        v-model="zhiying_zd"
                                        type="digit"
                                        label=""
                                        @blur="zhiying_zd <= 0 ? (zhiying_zd = 9) : zhiying_zd"
                                    />
                                    <span class="unit">%</span>
                                </div>
                                <span class="text" style="margin-left: 6px">时坚定持有</span>
                            </div>
                        </div>
                        <div class="condition-list">
                            <span class="label"></span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">直到最高收益回落</span>
                                <van-field
                                    v-model="huiluo_zd"
                                    type="digit"
                                    label=""
                                    @blur="huiluo_zd <= 0 ? (huiluo_zd = 1) : huiluo_zd"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>

                        <div class="condition-list" style="border: none">
                            <span class="label">策略止损</span>
                            <div class="c-l-right">
                                <span class="text" style="margin-right: 6px">收益率≤ -</span>
                                <van-field
                                    v-model="zhisun_zd"
                                    type="digit"
                                    label=""
                                    @blur="zhisun_zd <= 0 ? (zhisun_zd = 5) : zhisun_zd"
                                />
                                <span class="unit">%</span>
                            </div>
                        </div>
                    </div>

                    <van-action-sheet v-model="beginshow">
                        <div class="action-sheet-content">
                            <van-datetime-picker
                                v-model="beginCurrentDate"
                                type="date"
                                title="选择开始日期"
                                :min-date="beginMinDate"
                                :max-date="beginMaxDate"
                                @confirm="beginHandleConfirm"
                                @cancel="beginHandleCancel"
                            />
                        </div>
                    </van-action-sheet>

                    <van-action-sheet v-model="endshow">
                        <div class="action-sheet-content">
                            <van-datetime-picker
                                v-model="endCurrentDate"
                                type="date"
                                title="选择结束日期"
                                :min-date="endMinDate"
                                :max-date="endMaxDate"
                                @confirm="endHandleConfirm"
                                @cancel="endHandleCancel"
                            />
                        </div>
                    </van-action-sheet>
                </div>
            </div>

            <div class="bottom-pd">
                <div class="bottom-btn" v-if="!loading">
                    <div class="left" @click="checkedYzNum > 0 ? (showActionSheet = true) : ''">
                        已选中的因子 <span class="num">{{ checkedYzNum }}</span>
                    </div>
                    <van-button type="primary" class="r-btn" @click="openHcFun"
                        >{{ publicHcID ? '再次回测' : '立即回测' }}
                    </van-button>
                </div>

                <van-button loading-text="回测中..." :loading="loading" v-else class="setup-ing"
                    >规则校验中...
                </van-button>
            </div>
        </div>

        <takeOut
            :show="takeShow"
            :name="takeName"
            :btnText="takeBtnName"
            type="hc"
            @cancelBasis="cancelBasis"
            @linkGo="linkGo"
        ></takeOut>

        <!-- 大盘风控模版介绍说明 -->
        <van-popup v-model="viewIntroduction" :style="{ width: '70%' }" round>
            <div class="dpfkmbsm">
                <p class="title">大盘风控模版说明</p>

                <ul class="mbsmDialog">
                    <h2>MACD仓控模板</h2>
                    <li>
                        出现MACD&gt;0且MACD红柱没有出现持续萎缩则为强势市场；
                        <br />
                        出现MACD&lt;0且MACD绿柱暂未出现连续收缩则为弱势市场；
                        <br />
                        其余情况为震荡市场。
                    </li>

                    <h2>均线模板</h2>
                    <li>
                        根据自适应线变化来考量市场强弱，当指数变动开始加速偏离时定义为强势，反之则为弱势，其余情况为震荡市
                    </li>

                    <h2>成交额仓控模板</h2>
                    <li>
                        大盘成交量变化快线大于慢线时为强势市场；
                        <br />
                        大盘成交量变化快线小于慢线时为弱势市场；
                        <br />
                        其余为震荡市场
                    </li>

                    <h2>乖离仓控模板</h2>
                    <li>
                        收盘价正向偏离均线较大时是强势市场；
                        <br />
                        收盘价负向偏离均线较大时为弱势市场；
                        <br />
                        其余情况为震荡市场。
                    </li>

                    <h2>价格仓控模板</h2>
                    <li>
                        K线整体连续4天上移为强势市场；
                        <br />
                        K线整体连续4天下降为弱势市场；
                        <br />
                        其余为震荡市场。
                    </li>

                    <h2>价格均线仓控模板</h2>
                    <li>
                        收盘价站上5日线且5日平均线大于昨日为强势市场；
                        <br />
                        收盘价跌破5日线且5日平均线小于昨日为弱势市场；
                        <br />
                        其余为震荡市场。
                    </li>
                </ul>
            </div>
            <div class="gotit">
                <van-button type="info" @click="viewIntroduction = false">知道了</van-button>
            </div>
        </van-popup>

        <div class="van_picker">
            <van-popup v-model="fkmbPickerType" round position="bottom" :style="{ height: '30%' }">
                <van-picker
                    title="大盘风控模版"
                    show-toolbar
                    :columns="dpfkmbList"
                    @confirm="onConfirmDpfk"
                    @cancel="onCancelDpfk"
                    :default-index="dpfkmb_defaultIndex"
                />
            </van-popup>
        </div>

        <div class="van_picker">
            <van-popup
                v-model="qs_CwkzPickerType"
                round
                position="bottom"
                :style="{ height: '30%' }"
            >
                <van-picker
                    title="强势市场仓位控制"
                    show-toolbar
                    :columns="qs_cwkzList"
                    @confirm="onConfirmCwkz_qs"
                    @cancel="onCancelCwkz_qs"
                    :default-index="qs_defaultIndex"
                />
            </van-popup>
        </div>

        <div class="van_picker">
            <van-popup
                v-model="rs_CwkzPickerType"
                round
                position="bottom"
                :style="{ height: '30%' }"
            >
                <van-picker
                    title="弱势市场仓位控制"
                    show-toolbar
                    :columns="rs_cwkzList"
                    @confirm="onConfirmCwkz_rs"
                    @cancel="onCancelCwkz_rs"
                    :default-index="rs_defaultIndex"
                />
            </van-popup>
        </div>

        <div class="van_picker">
            <van-popup
                v-model="zd_CwkzPickerType"
                round
                position="bottom"
                :style="{ height: '30%' }"
            >
                <van-picker
                    :title="`震荡市场仓位控制`"
                    show-toolbar
                    :columns="zd_cwkzList"
                    @confirm="onConfirmCwkz_zd"
                    @cancel="onCancelCwkz_zd"
                    :default-index="zd_defaultIndex"
                />
            </van-popup>
        </div>
    </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import {
    judgeColor,
    toFixedNum,
    removeValueFromArray,
    dateFormat,
    formtTime,
    strToHexCharCode,
    factorCombinationToCode
} from '@/utils/format';
import { initiateLhHc } from '@/api/create.js';
import { getClientRedis, getInalysis } from '@/api/index.js';

export default {
    name: 'DyzArguments',
    mixins: [mixin],
    data() {
        return {
            currentCustom: -1,
            periodArr: [
                {
                    name: '2天',
                    checked: false
                },
                {
                    name: '3天',
                    checked: false
                },
                {
                    name: '5天',
                    checked: false
                },
                {
                    name: '10天',
                    checked: false
                },
                {
                    name: '20天',
                    checked: false
                },
                {
                    name: '30天',
                    checked: false
                },

                {
                    name: '60天',
                    checked: false
                },

                {
                    name: '自定义',
                    checked: false
                }
            ],
            capital: 100000, //初始化资金
            selectedPeriods: [], // 用于存储选中的 name 值的数组
            value: '',
            isCustomSelected: false, // 用于标记是否点击了自定义选项
            beginCurrentDate: '',
            endCurrentDate: '',
            newBeginCurrentDate: '',
            newEndCurrentDate: '',
            beginshow: false,
            endshow: false,
            beginMinDate: new Date(2014, 12, 31),
            beginMaxDate: new Date(),
            endMinDate: new Date(2014, 12, 31),
            endMaxDate: new Date(),
            loading: false,
            showAstrict: false,
            astrictValue: '',
            columnsAstrict: ['1只', '2只', '3只', '4只', '5只', '6只', '7只', '8只', '9只', '10只'], //持股上限 数据
            numValue: '', //单日买入数量
            showNum: false,
            columnsNum: [],
            astrictNum: 1,
            leftOrderValue: '',
            rightOrderValue: '',
            showLeftOrder: false,
            showRightOrder: false,
            columnsLeftOrder: [],
            columnsRightOrder: [
                {
                    value: 0,
                    label: '从大到小'
                },
                {
                    value: 1,
                    label: '从小到大'
                }
            ],
            zhiying: 9,
            huiluo: 1,
            zhisun: 5,

            //强势
            zhiying_qs: 14,
            huiluo_qs: 1,
            zhisun_qs: 7,

            //弱势
            zhiying_rs: 5,
            huiluo_rs: 1,
            zhisun_rs: 3,

            //震荡
            zhiying_zd: 9,
            huiluo_zd: 1,
            zhisun_zd: 5,

            sx_defaultIndex: 1, //持股上限默认值
            mrsl_defaultIndex: 0, //单日买入数量默认值
            mrsxLeft_defaultIndex: 0, //买入顺序-left默认值
            mrsxRight_defaultIndex: 0, //买入顺序-right默认值
            takeShow: false,
            takeName: '',
            takeBtnName: '',
            isShowKd: false,
            isShowCgzqText: false,
            dpfkmb: 0,
            //大盘风控-大盘风控模版
            dpfkmbData: {
                value: 0,
                text: 'MACD仓控模板'
            },
            fkmbPickerType: false,
            dpfkmb_defaultIndex: 0,
            dpfkmbList: [
                {
                    value: 0,
                    text: 'MACD仓控模板'
                },
                {
                    value: 1,
                    text: '均线模板'
                },
                {
                    value: 2,
                    text: '成交额仓控模板'
                },
                {
                    value: 3,
                    text: '乖离仓控模板'
                },
                {
                    value: 4,
                    text: '价格仓控模板'
                },
                {
                    value: 5,
                    text: '价格均线仓控模板'
                }
            ],

            //强势市场-仓位控制
            qs_Data: {
                value: 1,
                text: '满仓'
            },
            qs_CwkzPickerType: false,
            qs_defaultIndex: 0,
            qs_cwkzList: [
                {
                    value: 1,
                    text: '满仓'
                },
                {
                    value: 0.9,
                    text: '90%'
                },
                {
                    value: 0.8,
                    text: '80%'
                },
                {
                    value: 0.7,
                    text: '70%'
                },
                {
                    value: 0.6,
                    text: '60%'
                },
                {
                    value: 0.5,
                    text: '50%'
                },
                {
                    value: 0.4,
                    text: '40%'
                },
                {
                    value: 0.3,
                    text: '30%'
                },
                {
                    value: 0.2,
                    text: '20%'
                },
                {
                    value: 0.1,
                    text: '10%'
                },
                {
                    value: 0,
                    text: '空仓'
                }
            ],

            //弱势市场-仓位控制
            rs_Data: {
                value: 0,
                text: '空仓'
            },
            rs_CwkzPickerType: false,
            rs_defaultIndex: 10,
            rs_cwkzList: [
                {
                    value: 1,
                    text: '满仓'
                },
                {
                    value: 0.9,
                    text: '90%'
                },
                {
                    value: 0.8,
                    text: '80%'
                },
                {
                    value: 0.7,
                    text: '70%'
                },
                {
                    value: 0.6,
                    text: '60%'
                },
                {
                    value: 0.5,
                    text: '50%'
                },
                {
                    value: 0.4,
                    text: '40%'
                },
                {
                    value: 0.3,
                    text: '30%'
                },
                {
                    value: 0.2,
                    text: '20%'
                },
                {
                    value: 0.1,
                    text: '10%'
                },
                {
                    value: 0,
                    text: '空仓'
                }
            ],

            //震荡市场-仓位控制
            zd_Data: {
                value: 0.5,
                text: '50%'
            },
            zd_CwkzPickerType: false,
            zd_defaultIndex: 5,
            zd_cwkzList: [
                {
                    value: 1,
                    text: '满仓'
                },
                {
                    value: 0.9,
                    text: '90%'
                },
                {
                    value: 0.8,
                    text: '80%'
                },
                {
                    value: 0.7,
                    text: '70%'
                },
                {
                    value: 0.6,
                    text: '60%'
                },
                {
                    value: 0.5,
                    text: '50%'
                },
                {
                    value: 0.4,
                    text: '40%'
                },
                {
                    value: 0.3,
                    text: '30%'
                },
                {
                    value: 0.2,
                    text: '20%'
                },
                {
                    value: 0.1,
                    text: '10%'
                },
                {
                    value: 0,
                    text: '空仓'
                }
            ],
            viewIntroduction: false,
            // 选中的因子数量
            checkedYzNum: 0
        };
    },
    //计算属性
    computed: {
        checkedYzList: function () {
            return this.$store.state.checkedYzList; // 获取全局状态
        },
        Obj: function () {
            return this.$store.state.Obj; // 获取全局状态
        },
        contentNavBar: function () {
            return this.$store.state.contentNavBar; // 获取全局状态
        },
        publicHcID: function () {
            return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
        },
        groupYzList() {
            return this.$store.state.groupYzList;
        },
        checkedYzType(){
            return this.$store.state.checkedYzType;
        }
    },

    watch: {},
    components: {},
    filters: {},
    created() {
        this.getClientFun();
        if (this.$route.query.yzType == 'ETF') {
            this.columnsLeftOrder = [
                {
                    value: 0,
                    label: '成交额'
                },
                {
                    value: 1,
                    label: '涨跌幅'
                },
                {
                    value: 3,
                    label: '量比'
                },
                {
                    value: 7,
                    label: '振幅'
                }
            ];
            this.beginMinDate = new Date(
                window.LHJY_CONDITION.etf_start_time[0],
                window.LHJY_CONDITION.etf_start_time[1],
                window.LHJY_CONDITION.etf_start_time[2]
            );
            this.endMinDate = new Date(
                window.LHJY_CONDITION.etf_start_time[0],
                window.LHJY_CONDITION.etf_start_time[1],
                window.LHJY_CONDITION.etf_start_time[2]
            );
        } else {
            this.columnsLeftOrder = [
                {
                    value: 0,
                    label: '成交额'
                },
                {
                    value: 1,
                    label: '涨跌幅'
                },
                {
                    value: 2,
                    label: '换手率'
                },
                {
                    value: 3,
                    label: '量比'
                },
                {
                    value: 4,
                    label: '总市值'
                },
                {
                    value: 5,
                    label: '流通市值'
                },
                {
                    value: 6,
                    label: '市盈率TTM'
                },
                {
                    value: 7,
                    label: '振幅'
                }
            ];
            this.beginMinDate = new Date(
                window.LHJY_CONDITION.start_time[0],
                window.LHJY_CONDITION.start_time[1],
                window.LHJY_CONDITION.start_time[2]
            );
            this.endMinDate = new Date(
                window.LHJY_CONDITION.start_time[0],
                window.LHJY_CONDITION.start_time[1],
                window.LHJY_CONDITION.start_time[2]
            );
        }

        this.zhiying = window.LHJY_CONDITION.start_zy;
        this.huiluo = window.LHJY_CONDITION.end_zy;
        this.zhisun = window.LHJY_CONDITION.start_zs;

        //强势
        this.zhiying_qs = window.LHJY_CONDITION.start_zy_qs;
        this.huiluo_qs = window.LHJY_CONDITION.end_zy_qs;
        this.zhisun_qs = window.LHJY_CONDITION.start_zs_qs;

        //弱势
        this.zhiying_rs = window.LHJY_CONDITION.start_zy_rs;
        this.huiluo_rs = window.LHJY_CONDITION.end_zy_rs;
        this.zhisun_rs = window.LHJY_CONDITION.start_zs_rs;

        //震荡
        this.zhiying_zd = window.LHJY_CONDITION.start_zy_zd;
        this.huiluo_zd = window.LHJY_CONDITION.end_zy_zd;
        this.zhisun_zd = window.LHJY_CONDITION.start_zs_zd;
        this.checkedYzNumStatic();
    },
    mounted() {
        // if (window.DzhAppJs) {
        //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
        // }

        this.$store.commit('setBtnDisabled', false);

        // if (this.$route.query.userid && this.$route.query.factorid != this.Obj.factorList) {
        if (!this.$route.query.checkedYzList && this.$route.query.userid) {
            this.$store.commit('setPublicHcID', null);
            this.$store.commit('setCheckedYzList', []);
            let arr = [];
            let FactorName = this.$route.query.factornames.split(',');

            FactorName.forEach((i, index) => {
                arr[index] = {
                    FactorName: i
                };
            });

            this.$store.commit('setCheckedYzList', arr);

            //回测周期
            this.beginCurrentDate = new Date(this.getPreviousYear());
            this.endCurrentDate = new Date(this.getPreviousDay());
            this.newBeginCurrentDate = this.getPreviousYear();
            this.newEndCurrentDate = this.getPreviousDay();

            this.beginMaxDate = new Date(
                this.newEndCurrentDate.split('-')[0],
                this.newEndCurrentDate.split('-')[1] - 1,
                this.newEndCurrentDate.split('-')[2]
            );
            this.endMaxDate = new Date(
                this.newEndCurrentDate.split('-')[0],
                this.newEndCurrentDate.split('-')[1] - 1,
                this.newEndCurrentDate.split('-')[2]
            );

            this.getInalysisFun();
        } else {
            var receivedDays = [];
            if (this.Obj.isCustomSelected) {
                this.isCustomSelected = this.Obj.isCustomSelected;
                this.value = this.Obj.holdPeriodList;
                this.periodArr[7].checked = true;
                this.currentCustom = 7;
            } else {
                // 获取传入的天数数组（假设为 receivedDays）
                if (this.Obj.holdPeriodList) {
                    receivedDays = this.Obj.holdPeriodList.split(',');
                } else {
                    receivedDays = [2]; // 示例数据
                }
                // 遍历天数数组，选中对应的选项
                for (var day of receivedDays) {
                    var index = this.periodArr.findIndex((item) => item.name.includes(day));
                    if (index !== -1) {
                        this.periodArr[index].checked = true;
                        this.selectedPeriods.push(this.periodArr[index].name);
                    }
                }
            }

            //回测周期
            if (this.Obj.startDate && this.Obj.endDate) {
                this.beginCurrentDate = new Date(dateFormat('YYYY-MM-DD', this.Obj.startDate));
                this.endCurrentDate = new Date(dateFormat('YYYY-MM-DD', this.Obj.endDate));
                this.newBeginCurrentDate = dateFormat('YYYY-MM-DD', this.Obj.startDate);
                this.newEndCurrentDate = dateFormat('YYYY-MM-DD', this.Obj.endDate);
            } else {
                this.beginCurrentDate = new Date(this.getPreviousYear());
                this.endCurrentDate = new Date(this.getPreviousDay());
                this.newBeginCurrentDate = this.getPreviousYear();
                this.newEndCurrentDate = this.getPreviousDay();
            }

            this.beginMaxDate = new Date(
                this.newEndCurrentDate.split('-')[0],
                this.newEndCurrentDate.split('-')[1] - 1,
                this.newEndCurrentDate.split('-')[2]
            );
            this.endMaxDate = new Date(
                this.newEndCurrentDate.split('-')[0],
                this.newEndCurrentDate.split('-')[1] - 1,
                this.newEndCurrentDate.split('-')[2]
            );

            //初始化资金
            this.capital = this.Obj.startMoney || 100000;
            //持股上限
            this.astrictValue = this.Obj.PositionLimit
                ? this.Obj.PositionLimit + '只'
                : this.columnsAstrict[1];
            //持股上限select
            this.sx_defaultIndex = this.Obj.PositionLimit
                ? this.findIndexFromList(this.Obj.PositionLimit, this.columnsAstrict)
                : 0;

            //单日买入数量数组的值
            this.columnsNum = this.Obj.PositionLimit
                ? this.columnsAstrict.slice(
                      0,
                      this.findIndexFromList(this.Obj.PositionLimit, this.columnsAstrict) + 1
                  )
                : this.columnsAstrict.slice(0, 2);

            this.numValue = this.Obj.buyLimit ? this.Obj.buyLimit + '只' : '1只';
            //单日买入数量selsct 默认值
            this.mrsl_defaultIndex = this.Obj.buyLimit
                ? this.findIndexFromList(this.Obj.buyLimit, this.columnsNum)
                : 0;

            //买入顺序-left
            this.leftOrderValue = this.Obj.sortKind
                ? this.columnsLeftOrder[this.Obj.sortKind]
                : this.columnsLeftOrder[0];

            //买入顺序-left-select值
            this.mrsxLeft_defaultIndex = this.Obj.sortKind ? this.Obj.sortKind : 0;

            //买入顺序-right
            this.rightOrderValue = this.Obj.sortDirection
                ? this.columnsRightOrder[this.Obj.sortDirection]
                : this.columnsRightOrder[0];
            //买入顺序-right-select值
            this.mrsxRight_defaultIndex = this.Obj.sortDirection ? this.Obj.sortDirection : 0;

            //风控模型 是普通还是大盘择时交易
            this.dpfkmb = this.Obj.TradeRule || 0;

            //大盘风控模版 下拉
            this.dpfkmb_defaultIndex = this.findIndexByValue(
                this.dpfkmbList,
                this.Obj.RiskTemplate,
                0
            );
            this.dpfkmbData = this.dpfkmbList[this.dpfkmb_defaultIndex];
            //强势仓位控制 下拉
            this.qs_defaultIndex = this.findIndexByValue(
                this.qs_cwkzList,
                this.Obj.MightyRiskPosition,
                0
            );
            this.qs_Data = this.qs_cwkzList[this.qs_defaultIndex];
            //弱势仓位控制 下拉
            this.rs_defaultIndex = this.findIndexByValue(
                this.rs_cwkzList,
                this.Obj.WeaknessRiskPosition,
                10
            );
            this.rs_Data = this.rs_cwkzList[this.rs_defaultIndex];
            //震荡仓位控制 下拉
            this.zd_defaultIndex = this.findIndexByValue(
                this.zd_cwkzList,
                this.Obj.VibrateRiskPosition,
                5
            );
            this.zd_Data = this.rs_cwkzList[this.zd_defaultIndex];

            //收益率≥  普通
            this.zhiying = this.Obj.stopProfitHigh * 100 || window.LHJY_CONDITION.start_zy;
            //直到最高收益回落
            this.huiluo = this.Obj.stopProfitLow * 100 || window.LHJY_CONDITION.end_zy;
            //收益率≤
            this.zhisun = this.Obj.stopLoss * 100 || window.LHJY_CONDITION.start_zs;

            //收益率≥  强势
            this.zhiying_qs =
                this.Obj.MightyStopProfitHigh * 100 || window.LHJY_CONDITION.start_zy_qs;
            //直到最高收益回落
            this.huiluo_qs = this.Obj.MightyStopProfitLow * 100 || window.LHJY_CONDITION.end_zy_qs;
            //收益率≤
            this.zhisun_qs = this.Obj.MightyStopLoss * 100 || window.LHJY_CONDITION.start_zs_qs;

            //收益率≥  弱势
            this.zhiying_rs =
                this.Obj.WeaknessStopProfitHigh * 100 || window.LHJY_CONDITION.start_zy_rs;
            //直到最高收益回落
            this.huiluo_rs =
                this.Obj.WeaknessStopProfitLow * 100 || window.LHJY_CONDITION.end_zy_rs;
            //收益率≤
            this.zhisun_rs = this.Obj.WeaknessStopLoss * 100 || window.LHJY_CONDITION.start_zs_rs;

            //收益率≥  震荡
            this.zhiying_zd =
                this.Obj.VibrateStopProfitHigh * 100 || window.LHJY_CONDITION.start_zy_zd;
            //直到最高收益回落
            this.huiluo_zd = this.Obj.VibrateStopProfitLow * 100 || window.LHJY_CONDITION.end_zy_zd;
            //收益率≤
            this.zhisun_zd = this.Obj.VibrateStopLoss * 100 || window.LHJY_CONDITION.start_zs_zd;
        }
    },
    methods: {
        judgeColor,
        toFixedNum,
        formtTime,

        //根据传入的数组和值查找在数组里面的索引值
        findIndexByValue: function (arr, value, defaultNum) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].value == value) {
                    return i;
                }
            }
            return defaultNum; // 如果没有找到匹配的值，则返回 default  默认值
        },

        //查询是否显示扣豆
        getClientFun() {
            var _this = this;
            getClientRedis({})
                .then((res) => {
                    if (res.err == 200) {
                        var data = JSON.parse(res.data);
                        _this.setLocalData(data);
                        if (data.hc == 'true') {
                            _this.isShowKd = false;
                        } else {
                            _this.isShowKd = true;
                        }
                    } else {
                        _this.isShowKd = true;
                        _this.setLocalData();
                    }
                })
                .catch(() => {
                    _this.isShowKd = true;
                    _this.setLocalData();
                });
        },

        findIndexFromList: function (value, list) {
            const valueString = value + '只';
            for (let i = 0; i < list.length; i++) {
                if (list[i] == valueString) {
                    return i;
                }
            }

            return 0; // 如果未找到匹配值，则返回 0 表示未找到
        },

        //删除选中的因子 -
        delYz: function (item) {
            removeValueFromArray(this.checkedYzList, item.ID);
            this.$store.commit('setCheckedYzList', this.checkedYzList);
        },

        //选择周期
        handleClickCol(index) {
            if (index == this.periodArr.length - 1) {
                // 点击了自定义选项
                this.currentCustom = index;
                this.isCustomSelected = true; // 标记点击了自定义选项
                // 取消其他选项的选中状态
                this.periodArr.forEach((item, idx) => {
                    item.checked = idx == index;
                });
                // 清空选中的值数组
                this.selectedPeriods = [];
            } else {
                this.value = '';
                // 点击了非自定义选项
                if (this.currentCustom !== -1) {
                    // 取消自定义选项的选中状态
                    this.periodArr[this.currentCustom].checked = false;
                    this.currentCustom = -1;
                    this.isCustomSelected = false; // 取消自定义选项的标记
                }
                // 切换选中状态
                this.periodArr[index].checked = !this.periodArr[index].checked;

                // 更新选中的值数组
                var selectedPeriod = this.periodArr[index].name;
                if (this.periodArr[index].checked && index !== this.periodArr.length - 1) {
                    this.selectedPeriods.push(selectedPeriod);
                } else {
                    var selectedIndex = this.selectedPeriods.indexOf(selectedPeriod);
                    if (selectedIndex !== -1) {
                        this.selectedPeriods.splice(selectedIndex, 1);
                    }
                }
            }
        },

        //自定义周期失去焦点
        handleBlur: function () {
            // 删除非数字字符，保留逗号
            const cleanedValue = this.value.replace(/[^0-9,]/g, '');

            // 保留相邻的逗号中的一个
            const uniqueCommas = cleanedValue.replace(/,{2,}/g, ',');

            // 拆分字符串为数字数组
            const numbers = uniqueCommas.split(',').map(Number);

            // 过滤掉小于等于零的数字并限制最大值为60
            const filteredNumbers = numbers.filter((num) => num > 1 && num <= 99);

            // 截取前10条数字
            const slicedNumbers = filteredNumbers.slice(0, 10);

            // 排序数字数组
            const sortedNumbers = slicedNumbers.sort((a, b) => a - b);

            // 删除重复的数字
            const uniqueNumbers = [...new Set(sortedNumbers)];

            // 更新输入框的值
            this.value = uniqueNumbers.join(',');
        },

        //持股上限select
        onConfirmAstrict: function (value, index) {
            this.showAstrict = false;
            this.astrictValue = value;

            var matches = value.match(/^\d+/); // 匹配以数字开头的部分
            var number = matches ? matches[0] : null; // 获取匹配到的第一个结果

            this.columnsNum = [];
            for (var i = 1; i <= number; i++) {
                this.columnsNum.push(i + '只');
            }

            this.numValue = '1只';
        },
        onCancelAstrict: function (picker, value, index) {
            this.showAstrict = false;
        },

        //单日买入数量
        onConfirmNum: function (value, index) {
            this.showNum = false;
            this.numValue = value;
        },
        onCancelNum: function (picker, value, index) {
            this.showNum = false;
        },

        //买入顺序-left
        onConfirmLeftOrder: function (value, index) {
            this.showLeftOrder = false;
            this.leftOrderValue = this.columnsLeftOrder[index];
        },
        onCancelLeftOrder: function (picker, value, index) {
            this.showLeftOrder = false;
        },

        //买入顺序-right
        onConfirmRightOrder: function (value, index) {
            this.showRightOrder = false;
            this.rightOrderValue = this.columnsRightOrder[index];
        },
        onCancelRightOrder: function (picker, value, index) {
            this.showRightOrder = false;
        },

        //格式化时间
        timeFormat: function (time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var day = date.getDate().toString().padStart(2, '0');
            return year + '-' + month + '-' + day;
        },

        //获取日期的前一天
        getPreviousDay: function () {
            var currentDate = new Date();
            var previousDate = new Date(currentDate);
            previousDate.setDate(currentDate.getDate() - 1);

            var year = previousDate.getFullYear();
            var month = (previousDate.getMonth() + 1).toString().padStart(2, '0');
            var day = previousDate.getDate().toString().padStart(2, '0');

            var formattedDate = year + '-' + month + '-' + day;
            return formattedDate;
        },
        //获取日期的前一年
        getPreviousYear: function () {
            let currentDate = new Date();
            let previousYearDate = new Date(
                currentDate.getFullYear() - 1,
                currentDate.getMonth(),
                currentDate.getDate()
            );

            let year = previousYearDate.getFullYear();
            let month = String(previousYearDate.getMonth() + 1).padStart(2, '0');
            let day = String(previousYearDate.getDate()).padStart(2, '0');

            return year + '-' + month + '-' + day;
        },

        beginHandleConfirm: function (i) {
            this.beginCurrentDate = this.timeFormat(i);
            this.newBeginCurrentDate = this.timeFormat(i);
            this.beginshow = false;

            let isValid = this.compareDates(this.newBeginCurrentDate, this.newEndCurrentDate);
            if (isValid) {
                this.$toast('结束日期不能小于或等于开始日期');
            }
        },
        beginHandleCancel: function () {
            this.beginshow = false;
        },
        endHandleConfirm: function (i) {
            this.endCurrentDate = this.timeFormat(i);
            this.newEndCurrentDate = this.timeFormat(i);

            this.endshow = false;

            let isValid = this.compareDates(this.newBeginCurrentDate, this.newEndCurrentDate);
            if (isValid) {
                this.$toast('结束日期不能小于或等于开始日期');
            }
        },
        endHandleCancel: function () {
            this.endshow = false;
        },

        //判断结束时间不能小于开始时间
        compareDates: function (startDate, endDate) {
            let start = new Date(startDate);
            let end = new Date(endDate);

            if (end > start) {
                return false; // endDate 大于 startDate
            } else {
                return true; // endDate 小于等于 startDate
            }
        },

        cancelBasis: function () {
            this.takeShow = false;
        },

        linkGo: function () {
            let _this = this;
            _this.takeShow = false;
            if (_this.capital < 100000 || _this.capital == '') {
                _this.$toast('初始化资金不能小于10万');
                return false;
            } else if (_this.capital > 10000000) {
                _this.$toast('初始化资金不能大于1000万');
                return false;
            } else if (_this.capital.toString().startsWith('0')) {
                _this.$toast('初始化资金输入格式不正确');
                return false;
            }

            if (!_this.checkedYzList.length) {
                _this.$toast('至少添加一个因子');

                return false;
            }
            if (
                (!_this.selectedPeriods.length && !_this.isCustomSelected) ||
                (_this.isCustomSelected && _this.value == '')
            ) {
                _this.isShowCgzqText = true;
                // _this.$toast('请选择持股周期');

                return false;
            } else {
                _this.isShowCgzqText = false;
            }

            _this.loading = true;

            //把持股周期从大到小排序
            var cgzq = _this.selectedPeriods
                .map((item) => parseInt(item, 10)) // 将字符串转换为数字
                .sort((a, b) => a - b); // 按从小到大排序

            // var idArray = _this.checkedYzList.map((obj) => {
            //     if (obj.yzType != 0) {
            //         //自选和模版的取info字段 其他的直接取id
            //         if (obj.yzType == 4) {
            //             return '&F' + strToHexCharCode(obj.Info);
            //         } else {
            //             return '&' + obj.Info;
            //         }
            //     } else {
            //         return '&' + obj.ID;
            //     }
            // });

            // var hexyzIds = ':' + strToHexCharCode(':' + idArray.join('') + '&');

            // var factorList;
            // if (_this.$route.query.checkedYzList || !_this.$route.query.userid) {
            //     factorList = hexyzIds;
            // } else if (_this.$route.query.userid && !_this.$route.query.checkedYzList) {
            //     factorList = _this.$route.query.factorid;
            // }

            // 组合因子交并集
            var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);

            var params = {};
            if (_this.dpfkmb == 0) {
                params = {
                    factorList: hexYzObj.hexyzIds, //string 因子列表
                    holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                    startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                    endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                    startMoney: _this.capital, //初始资金
                    PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                    buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                    sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                    sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                    stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                    stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                    stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                    buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                    TradeRule: 0 //        int   交易规则 0:普通交易 1:大盘风控择时交易
                };
            } else {
                params = {
                    factorList: hexYzObj.hexyzIds, //string 因子列表
                    holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                    startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                    endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                    startMoney: _this.capital, //初始资金
                    PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                    buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                    sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                    sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                    stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                    stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                    stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                    buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                    TradeRule: 1, //        int   交易规则 0:普通交易 1:大盘风控择时交易

                    RiskTemplate: _this.dpfkmbData.value, //  Int   风控模板 目前有6种，<br/>分别是 0:MACD仓控模板 1:均线模板<br/>2:成交额仓控模板 3:乖离仓控模板<br/>4:价格仓控模板 5:价格均线仓控模板

                    MightyRiskPosition: _this.qs_Data.value, //float 强势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                    MightyStopProfitHigh: _this.zhiying_qs / 100, //float 强势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                    MightyStopProfitLow: _this.huiluo_qs / 100, //float 强势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                    MightyStopLoss:
                        _this.zhisun_qs < 0 ? _this.zhisun_qs / 100 : -_this.zhisun_qs / 100, //float 强势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                    WeaknessRiskPosition: _this.rs_Data.value, //float 弱势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                    WeaknessStopProfitHigh: _this.zhiying_rs / 100, //float 弱势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                    WeaknessStopProfitLow: _this.huiluo_rs / 100, //float 弱势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                    WeaknessStopLoss:
                        _this.zhisun_rs < 0 ? _this.zhisun_rs / 100 : -_this.zhisun_rs / 100, //float 弱势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                    VibrateRiskPosition: _this.zd_Data.value, //float 震荡风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                    VibrateStopProfitHigh: _this.zhiying_zd / 100, //float 震荡止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                    VibrateStopProfitLow: _this.huiluo_zd / 100, //float 震荡止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                    VibrateStopLoss:
                        _this.zhisun_zd < 0 ? _this.zhisun_zd / 100 : -_this.zhisun_zd / 100 //float 震荡止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)
                };
            }

            initiateLhHc(params)
                .then((res) => {
                    _this.loading = false;
                    let Obj = {};
                    if (_this.dpfkmb == 0) {
                        //如果是普通交易规则
                        Obj = {
                            apiData: res.data,
                            factorList: hexYzObj.hexyzIds, //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                            endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            startMoney: _this.capital, //初始资金
                            PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                            buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                            sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                            sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                            stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                            stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                            stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                            buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                            TradeRule: 0, //        int   交易规则 0:普通交易 1:大盘风控择时交易
                            isEdit: _this.publicHcID ? true : false //是否是编辑
                        };
                    } else {
                        //如果是大盘择时交易

                        Obj = {
                            apiData: res.data,
                            factorList: hexYzObj.hexyzIds, //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                            endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            startMoney: _this.capital, //初始资金
                            PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                            buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                            sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                            sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                            stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                            stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                            stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                            buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                            TradeRule: 1, //        int   交易规则 0:普通交易 1:大盘风控择时交易
                            isEdit: _this.publicHcID ? true : false, //是否是编辑

                            RiskTemplate: _this.dpfkmbData.value, //  Int   风控模板 目前有6种，<br/>分别是 0:MACD仓控模板 1:均线模板<br/>2:成交额仓控模板 3:乖离仓控模板<br/>4:价格仓控模板 5:价格均线仓控模板

                            MightyRiskPosition: _this.qs_Data.value, //float 强势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                            MightyStopProfitHigh: _this.zhiying_qs / 100, //float 强势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                            MightyStopProfitLow: _this.huiluo_qs / 100, //float 强势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                            MightyStopLoss:
                                _this.zhisun_qs < 0
                                    ? _this.zhisun_qs / 100
                                    : -_this.zhisun_qs / 100, //float 强势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                            WeaknessRiskPosition: _this.rs_Data.value, //float 弱势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                            WeaknessStopProfitHigh: _this.zhiying_rs / 100, //float 弱势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                            WeaknessStopProfitLow: _this.huiluo_rs / 100, //float 弱势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                            WeaknessStopLoss:
                                _this.zhisun_rs < 0
                                    ? _this.zhisun_rs / 100
                                    : -_this.zhisun_rs / 100, //float 弱势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                            VibrateRiskPosition: _this.zd_Data.value, //float 震荡风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                            VibrateStopProfitHigh: _this.zhiying_zd / 100, //float 震荡止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                            VibrateStopProfitLow: _this.huiluo_zd / 100, //float 震荡止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                            VibrateStopLoss:
                                _this.zhisun_zd < 0 ? _this.zhisun_zd / 100 : -_this.zhisun_zd / 100 //float 震荡止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)
                        };
                    }

                    _this.$store.commit('setObj', Obj);

                    if (res.err == 200) {
                        _this.$toast('回测成功');

                        const query = {
                            token: _this.$route.query.token || '',
                            HashID: res.data.HashID,
                            source: _this.$route.query.source,
                            mySource: _this.$route.query.mySource, //用来标注是从个人中心过去的
                            themeStyleVs: _this.$route.query.themeStyleVs || 0,
                            version: _this.$route.query.version || '',
                            yzType: _this.$route.query.yzType || 'A',
                            zxgType: _this.$route.query.zxgType || 0,
                            mark: _this.$route.query.mark || ''
                        };

                        if (_this.$route.query.checkedYzList) {
                            query.userid = _this.$route.query.userid;
                            query.factorid = _this.$route.query.factorid;
                            query.factornames = _this.$route.query.userid;
                            query.checkedYzList = _this.$route.query.checkedYzList;
                        } else if (_this.$route.query.userid && !_this.$route.query.checkedYzList) {
                            query.userid = _this.$route.query.userid;
                            query.factorid = _this.$route.query.factorid;
                            query.factornames = _this.$route.query.userid;
                        }

                        _this.$router.push({
                            path: '/lhhc-preview',
                            name: 'Lhhc-preview',
                            query: query
                        });
                    } else {
                        _this.$toast(res.msg);
                    }
                })
                .catch((err) => {
                    _this.loading = false;
                    _this.$toast(err);
                });
        },

        openHcFun: function () {
            let _this = this;
            if (_this.isShowKd) {
                _this.takeName = '每次使用回测功能需消耗 2个慧豆';
                _this.takeBtnName = '继续回测';
                _this.takeShow = true;
                return false;
            }

            if (_this.capital < 100000 || _this.capital == '') {
                _this.$toast('初始化资金不能小于10万');
                return false;
            } else if (_this.capital > 10000000) {
                _this.$toast('初始化资金不能大于1000万');
                return false;
            } else if (_this.capital.toString().startsWith('0')) {
                _this.$toast('初始化资金输入格式不正确');
                return false;
            }

            if (!_this.checkedYzList.length) {
                _this.$toast('至少添加一个因子');

                return false;
            }
            if (
                (!_this.selectedPeriods.length && !_this.isCustomSelected) ||
                (_this.isCustomSelected && _this.value == '')
            ) {
                _this.isShowCgzqText = true;
                // _this.$toast('请选择持股周期');

                return false;
            } else {
                _this.isShowCgzqText = false;
            }

            _this.loading = true;

            //把持股周期从大到小排序
            var cgzq = _this.selectedPeriods
                .map((item) => parseInt(item, 10)) // 将字符串转换为数字
                .sort((a, b) => a - b); // 按从小到大排序

            // var idArray = _this.checkedYzList.map((obj) => {
            //     if (obj.yzType != 0) {
            //         //自选和模版的取info字段 其他的直接取id
            //         if (obj.yzType == 4) {
            //             return '&F' + strToHexCharCode(obj.Info);
            //         } else {
            //             return '&' + obj.Info;
            //         }
            //     } else {
            //         return '&' + obj.ID;
            //     }
            // });

            // var hexyzIds = ':' + strToHexCharCode(':' + idArray.join('') + '&');

            // var factorList;
            // if (_this.$route.query.checkedYzList || !_this.$route.query.userid) {
            //     factorList = hexyzIds;
            // } else if (_this.$route.query.userid && !_this.$route.query.checkedYzList) {
            //     factorList = _this.$route.query.factorid;
            // }


            // 组合因子交并集
            var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);
            var params = {};
            if (_this.dpfkmb == 0) {
                params = {
                    factorList: hexYzObj.hexyzIds, //string 因子列表
                    holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                    startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                    endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                    startMoney: _this.capital, //初始资金
                    PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                    buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                    sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                    sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                    stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                    stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                    stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                    buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                    TradeRule: 0 //        int   交易规则 0:普通交易 1:大盘风控择时交易
                };
            } else {
                params = {
                    factorList: hexYzObj.hexyzIds, //string 因子列表
                    holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                    startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                    endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                    startMoney: _this.capital, //初始资金
                    PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                    buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                    sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                    sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                    stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                    stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                    stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                    buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                    TradeRule: 1, //        int   交易规则 0:普通交易 1:大盘风控择时交易

                    RiskTemplate: _this.dpfkmbData.value, //  Int   风控模板 目前有6种，<br/>分别是 0:MACD仓控模板 1:均线模板<br/>2:成交额仓控模板 3:乖离仓控模板<br/>4:价格仓控模板 5:价格均线仓控模板

                    MightyRiskPosition: _this.qs_Data.value, //float 强势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                    MightyStopProfitHigh: _this.zhiying_qs / 100, //float 强势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                    MightyStopProfitLow: _this.huiluo_qs / 100, //float 强势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                    MightyStopLoss:
                        _this.zhisun_qs < 0 ? _this.zhisun_qs / 100 : -_this.zhisun_qs / 100, //float 强势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                    WeaknessRiskPosition: _this.rs_Data.value, //float 弱势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                    WeaknessStopProfitHigh: _this.zhiying_rs / 100, //float 弱势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                    WeaknessStopProfitLow: _this.huiluo_rs / 100, //float 弱势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                    WeaknessStopLoss:
                        _this.zhisun_rs < 0 ? _this.zhisun_rs / 100 : -_this.zhisun_rs / 100, //float 弱势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                    VibrateRiskPosition: _this.zd_Data.value, //float 震荡风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                    VibrateStopProfitHigh: _this.zhiying_zd / 100, //float 震荡止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                    VibrateStopProfitLow: _this.huiluo_zd / 100, //float 震荡止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                    VibrateStopLoss:
                        _this.zhisun_zd < 0 ? _this.zhisun_zd / 100 : -_this.zhisun_zd / 100 //float 震荡止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)
                };
            }

            initiateLhHc(params)
                .then((res) => {
                    _this.loading = false;

                    let Obj = {};
                    if (_this.dpfkmb == 0) {
                        //如果是普通交易规则
                        Obj = {
                            apiData: res.data,
                            factorList: hexYzObj.hexyzIds, //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                            endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            startMoney: _this.capital, //初始资金
                            PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                            buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                            sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                            sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                            stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                            stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                            stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                            buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                            TradeRule: 0, //        int   交易规则 0:普通交易 1:大盘风控择时交易
                            isEdit: _this.publicHcID ? true : false //是否是编辑
                        };
                    } else {
                        //如果是大盘择时交易

                        Obj = {
                            apiData: res.data,
                            factorList: hexYzObj.hexyzIds, //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                            endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            startMoney: _this.capital, //初始资金
                            PositionLimit: _this.astrictValue.replace('只', ''), //持仓股票数上限
                            buyLimit: _this.numValue.replace('只', ''), //单日买入股票数上限
                            sortKind: _this.leftOrderValue.value, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
                            sortDirection: _this.rightOrderValue.value, //排序方向0~1 0:从大到小 1:从小到大
                            stopProfitHigh: _this.zhiying / 100, //止盈卖出高水位线 eg:0.07就是7%
                            stopProfitLow: _this.huiluo / 100, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
                            stopLoss: _this.zhisun < 0 ? _this.zhisun / 100 : -_this.zhisun / 100, //止损卖出水位线 eg:-0.05就是-5%
                            buyType: 0, //买入方式 0:开盘买入 1:收盘买入
                            TradeRule: 1, //        int   交易规则 0:普通交易 1:大盘风控择时交易
                            isEdit: _this.publicHcID ? true : false, //是否是编辑

                            RiskTemplate: _this.dpfkmbData.value, //  Int   风控模板 目前有6种，<br/>分别是 0:MACD仓控模板 1:均线模板<br/>2:成交额仓控模板 3:乖离仓控模板<br/>4:价格仓控模板 5:价格均线仓控模板

                            MightyRiskPosition: _this.qs_Data.value, //float 强势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                            MightyStopProfitHigh: _this.zhiying_qs / 100, //float 强势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                            MightyStopProfitLow: _this.huiluo_qs / 100, //float 强势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                            MightyStopLoss:
                                _this.zhisun_qs < 0
                                    ? _this.zhisun_qs / 100
                                    : -_this.zhisun_qs / 100, //float 强势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                            WeaknessRiskPosition: _this.rs_Data.value, //float 弱势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                            WeaknessStopProfitHigh: _this.zhiying_rs / 100, //float 弱势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                            WeaknessStopProfitLow: _this.huiluo_rs / 100, //float 弱势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                            WeaknessStopLoss:
                                _this.zhisun_rs < 0
                                    ? _this.zhisun_rs / 100
                                    : -_this.zhisun_rs / 100, //float 弱势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                            VibrateRiskPosition: _this.zd_Data.value, //float 震荡风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                            VibrateStopProfitHigh: _this.zhiying_zd / 100, //float 震荡止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                            VibrateStopProfitLow: _this.huiluo_zd / 100, //float 震荡止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                            VibrateStopLoss:
                                _this.zhisun_zd < 0 ? _this.zhisun_zd / 100 : -_this.zhisun_zd / 100 //float 震荡止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)
                        };
                    }

                    _this.$store.commit('setObj', Obj);

                    if (res.err == 200) {
                        _this.$toast('回测成功');

                        const query = {
                            token: _this.$route.query.token || '',
                            HashID: res.data.HashID,
                            source: _this.$route.query.source,
                            mySource: _this.$route.query.mySource, //用来标注是从个人中心过去的
                            themeStyleVs: _this.$route.query.themeStyleVs || 0,
                            version: _this.$route.query.version || '',
                            yzType: _this.$route.query.yzType || 'A',
                            zxgType: _this.$route.query.zxgType || 0,
                            mark: this.$route.query.mark || ''
                        };

                        if (_this.$route.query.checkedYzList) {
                            query.userid = _this.$route.query.userid;
                            query.factorid = _this.$route.query.factorid;
                            query.factornames = _this.$route.query.userid;
                            query.checkedYzList = _this.$route.query.checkedYzList;
                        } else if (_this.$route.query.userid && !_this.$route.query.checkedYzList) {
                            query.userid = _this.$route.query.userid;
                            query.factorid = _this.$route.query.factorid;
                            query.factornames = _this.$route.query.userid;
                        }

                        _this.$router.push({
                            path: '/lhhc-preview',
                            name: 'Lhhc-preview',
                            query: query
                        });
                    } else {
                        _this.$toast(res.msg);
                    }
                })
                .catch((err) => {
                    _this.loading = false;
                    _this.$toast(err);
                });
        },
        goBack: function () {
            if (this.$route.query.userid) {
                location.href = 'dzh_browser_url&goto=0&screen=263';
            } else {
                const query = {
                    source: this.$route.query.source, //用来标注是从多因子还是量化过去的
                    type: 'add',
                    token: this.$route.query.token || '',
                    mySource: this.$route.query.mySource, //用来标注是从个人中心过去的
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType: this.$route.query.yzType || 'A',
                    createType: this.$route.query.createType || '',
                    dtzhHcCheckedYzList: this.$route.query.dtzhHcCheckedYzList || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
                    publicHcID: this.publicHcID,
                    zxgType: this.$route.query.zxgType || 0,
                    mark: this.$route.query.mark || ''
                };

                if (this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                    query.checkedYzList = this.$route.query.checkedYzList;
                } else if (this.$route.query.userid && !this.$route.query.checkedYzList) {
                    query.userid = this.$route.query.userid;
                    query.factorid = this.$route.query.factorid;
                    query.factornames = this.$route.query.userid;
                }

                this.$router.push({
                    path: '/checkedYz',
                    name: 'CheckedYz',
                    query: query
                });
            }
        },

        // 根据app客户端 带过来的参数获取条件参数
        getInalysisFun() {
            let _this = this;

            _this.$toast.loading({
                message: '加载中...',
                overlay: true,
                duration: 0
            });

            let obj = {
                userid: decodeURIComponent(_this.getUrlQuery('userid')),
                factorlist: decodeURIComponent(_this.getUrlQuery('factorid')),
                startdate: _this.formtTime(_this.getLastYear(), 'yyyyMMdd'),
                enddate: _this.formtTime(_this.getLastDay(), 'yyyyMMdd')
            };

            getInalysis(obj)
                .then((res) => {
                    _this.$toast.clear();
                    if (res.err == 200) {
                        //持股周期

                        var receivedDays = [];

                        // 获取传入的天数数组（假设为 receivedDays）
                        if (res.data.BestParamResult.HoldPeriod) {
                            receivedDays =
                                res.data.BestParamResult.HoldPeriod.toString().split(',');
                        } else {
                            receivedDays = [2]; // 示例数据
                        }

                        // 遍历天数数组，选中对应的选项
                        for (var day of receivedDays) {
                            var index = _this.periodArr.findIndex((item) =>
                                item.name.includes(day)
                            );
                            if (index !== -1) {
                                _this.periodArr[index].checked = true;
                                _this.selectedPeriods.push(_this.periodArr[index].name);
                            }
                        }

                        //初始化资金
                        _this.capital = res.data.BestParamResult.StartMoney || 100000;

                        //持股上限
                        _this.astrictValue = res.data.BestParamResult.PosLimit
                            ? res.data.BestParamResult.PosLimit + '只'
                            : _this.columnsAstrict[1];
                        //持股上限select
                        _this.sx_defaultIndex = res.data.BestParamResult.PosLimit
                            ? _this.findIndexFromList(
                                  res.data.BestParamResult.PosLimit,
                                  _this.columnsAstrict
                              )
                            : 0;

                        //单日买入数量数组的值
                        _this.columnsNum = res.data.BestParamResult.PosLimit
                            ? _this.columnsAstrict.slice(
                                  0,
                                  _this.findIndexFromList(
                                      res.data.BestParamResult.PosLimit,
                                      _this.columnsAstrict
                                  ) + 1
                              )
                            : _this.columnsAstrict.slice(0, 2);

                        _this.numValue = res.data.BestParamResult.BuyLimit
                            ? res.data.BestParamResult.BuyLimit + '只'
                            : '1只';
                        //单日买入数量selsct 默认值
                        _this.mrsl_defaultIndex = res.data.BestParamResult.BuyLimit
                            ? _this.findIndexFromList(
                                  res.data.BestParamResult.BuyLimit,
                                  _this.columnsNum
                              )
                            : 0;

                        //买入顺序-left
                        _this.leftOrderValue = res.data.BestParamResult.SortKind
                            ? _this.columnsLeftOrder[res.data.BestParamResult.SortKind]
                            : _this.columnsLeftOrder[0];

                        //买入顺序-left-select值
                        _this.mrsxLeft_defaultIndex = res.data.BestParamResult.SortKind
                            ? res.data.BestParamResult.SortKind
                            : 0;

                        //买入顺序-right
                        _this.rightOrderValue = res.data.BestParamResult.SortDirection
                            ? _this.columnsRightOrder[res.data.BestParamResult.SortDirection]
                            : _this.columnsRightOrder[0];
                        //买入顺序-right-select值
                        _this.mrsxRight_defaultIndex = res.data.BestParamResult.SortDirection
                            ? res.data.BestParamResult.SortDirection
                            : 0;

                        //大盘风控模版 下拉
                        _this.dpfkmb_defaultIndex = _this.findIndexByValue(
                            _this.dpfkmbList,
                            res.data.BestParamResult.RiskTemplate,
                            0
                        );

                        _this.dpfkmbData = _this.dpfkmbList[_this.dpfkmb_defaultIndex];
                        //强势仓位控制 下拉
                        _this.qs_defaultIndex = _this.findIndexByValue(
                            _this.qs_cwkzList,
                            res.data.BestParamResult.MightyRiskPosition,
                            0
                        );

                        _this.qs_Data = _this.qs_cwkzList[_this.qs_defaultIndex];
                        //弱势仓位控制 下拉
                        _this.rs_defaultIndex = _this.findIndexByValue(
                            _this.rs_cwkzList,
                            res.data.BestParamResult.WeaknessRiskPosition,
                            10
                        );

                        _this.rs_Data = _this.rs_cwkzList[_this.rs_defaultIndex];
                        //震荡仓位控制 下拉
                        _this.zs_defaultIndex = _this.findIndexByValue(
                            _this.zd_cwkzList,
                            res.data.BestParamResult.VibrateRiskPosition,
                            5
                        );

                        _this.zd_Data = _this.rs_cwkzList[_this.zd_defaultIndex];

                        //收益率≥
                        _this.zhiying =
                            res.data.BestParamResult.stopProfitHigh * 100 ||
                            window.LHJY_CONDITION.start_zy;
                        //直到最高收益回落
                        _this.huiluo =
                            res.data.BestParamResult.stopProfitLow * 100 ||
                            window.LHJY_CONDITION.end_zy;
                        //收益率≤
                        _this.zhisun =
                            res.data.BestParamResult.stopLossRate * 100 ||
                            window.LHJY_CONDITION.start_zs;

                        //收益率≥  --强势
                        _this.zhiying_qs =
                            res.data.BestParamResult.MightyStopProfitHigh * 100 ||
                            window.LHJY_CONDITION.start_zy_qs;
                        //直到最高收益回落
                        _this.huiluo_qs =
                            res.data.BestParamResult.MightyStopProfitLow * 100 ||
                            window.LHJY_CONDITION.end_zy_qs;
                        //收益率≤
                        _this.zhisun_qs =
                            res.data.BestParamResult.MightyStopLoss * 100 ||
                            window.LHJY_CONDITION.start_zs_qs;

                        //收益率≥--弱势
                        _this.zhiying_rs =
                            res.data.BestParamResult.WeaknessStopProfitHigh * 100 ||
                            window.LHJY_CONDITION.start_zy_rs;
                        //直到最高收益回落
                        _this.huiluo_rs =
                            res.data.BestParamResult.WeaknessStopProfitLow * 100 ||
                            window.LHJY_CONDITION.end_zy_rs;
                        //收益率≤
                        _this.zhisun_rs =
                            res.data.BestParamResult.WeaknessStopLoss * 100 ||
                            window.LHJY_CONDITION.start_zs_rs;

                        //收益率≥--震荡
                        _this.zhiying_zd =
                            res.data.BestParamResult.VibrateStopProfitHigh * 100 ||
                            window.LHJY_CONDITION.start_zy_zd;
                        //直到最高收益回落
                        _this.huiluo_zd =
                            res.data.BestParamResult.VibrateStopProfitLow * 100 ||
                            window.LHJY_CONDITION.end_zy_zd;
                        //收益率≤
                        _this.zhisun_zd =
                            res.data.BestParamResult.VibrateStopLoss * 100 ||
                            window.LHJY_CONDITION.start_zs_zd;
                    } else {
                        _this.$toast(res.err.msg);
                    }
                })
                .catch((err) => {
                    _this.$toast(err);
                });
        },

        onConfirmDpfk(value) {
            this.dpfkmbData = value;
            this.fkmbPickerType = false;
        },

        onCancelDpfk() {
            this.fkmbPickerType = false;
        },

        //强势
        onConfirmCwkz_qs(value) {
            this.qs_Data = value;
            this.qs_CwkzPickerType = false;
        },

        onCancelCwkz_qs() {
            this.qs_CwkzPickerType = false;
        },
        //弱势
        onConfirmCwkz_rs(value) {
            this.rs_Data = value;
            this.rs_CwkzPickerType = false;
        },

        onCancelCwkz_rs() {
            this.rs_CwkzPickerType = false;
        },

        //震荡
        onConfirmCwkz_zd(value) {
            this.zd_Data = value;
            this.zd_CwkzPickerType = false;
        },

        onCancelCwkz_zd() {
            this.zd_CwkzPickerType = false;
        },
        // 计算选中的因子
        checkedYzNumStatic() {
            console.log('groupYzList', this.groupYzList);

            const allIDs = this.groupYzList.flat();
            this.checkedYzNum = this.checkedYzList.length + allIDs.length;
        }
    }
};
</script>
<style lang="less" scoped>
.h2 {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
}

.division {
    height: 8px;
    background: #f8f9fc;
    margin: 12px -16px;
}

.index-info {
    position: relative;

    .content {
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .yz-list {
            padding: 16px;

            .yz-ul {
                border-radius: 8px;
                padding: 4px 8px;
                background: rgba(247, 247, 252, 0.64);
                margin-top: 8px;

                li {
                    margin: 6px 0;
                    border: 1px solid #e7e7e7;
                    padding: 3.5px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #fff;

                    .a-left {
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.9);
                        padding-left: 9.5px;

                        .gs {
                            border-radius: 20px;
                            border: 1.5px solid #2999df;
                            padding: 0 8px;
                            color: #2999df;
                            font-size: 10px;
                            flex-shrink: 0;
                            height: 16px;
                            margin-top: 2px;
                            margin-left: 4px;
                            display: flex;
                            align-items: center;
                        }

                        .XiFenZhongLei {
                            font-size: 10px;
                            color: #999;
                        }
                    }

                    .a-right {
                        border-radius: 4px;
                        padding: 8px 12px;
                        background: rgba(0, 0, 0, 0.02);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 50%;
                        font-size: 12px;
                        color: #555;

                        img {
                            width: 17px;
                            height: 16px;
                            flex-shrink: 0;
                        }
                    }
                }
            }
        }

        .condition {
            background: #fff;
            border-radius: 8px 8px 0 0;
            padding: 16px 16px 90px;

            .condition-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #f2f2f2;
                padding: 8px 0;

                .label {
                    color: #000;
                    font-size: 14px;
                    flex-shrink: 0;
                    margin-right: 20px;
                }

                .c-l-right {
                    position: relative;
                    display: flex;
                    align-items: center;

                    ::v-deep {
                        .van-cell {
                            padding: 0;
                        }

                        .van-field__control,
                        .imitation-select {
                            width: 120px;
                            height: 32px;
                            line-height: 32px;
                            padding: 0 22px 0 12px;
                            border-radius: 6px;
                            border: 1px solid #e5e5e5;
                        }
                    }

                    .unit {
                        position: absolute;
                        top: 5px;
                        right: 8px;
                        background: #fff;
                    }

                    .imitation-select {
                        position: relative;

                        .arrow-down {
                            position: absolute;
                            font-size: 15px;
                            right: 7px;
                            top: 7px;
                        }
                    }

                    .mrsj-button {
                        width: 120px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        padding: 0 12px 0 12px;
                        border-radius: 6px;
                        background: #f7f7fc;
                        color: #999;
                        font-size: 14px;
                    }

                    .text {
                        flex-shrink: 0;
                    }
                }

                .van_picker {
                }
            }

            .fk_title {
                font-weight: 600;
                color: rgba(0, 0, 0, 0.9);
                font-size: 16px;
                padding-top: 11px;
                display: flex;
                align-items: center;
                i {
                    width: 3px;
                    height: 12px;
                    background: #286df7;
                    border-radius: 13px;
                    margin-right: 6px;
                }
            }

            .period {
                border-bottom: 1px solid #f2f2f2;
                padding-bottom: 16px;

                ::v-deep {
                    .van-col {
                        div {
                            height: 32px;
                            border-radius: 6px;
                            border: 1px solid #e5e5e5;
                            margin-top: 8px;
                            font-size: 14px;
                            font-weight: normal;
                            color: #555;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .active {
                            background: rgba(40, 109, 247, 0.06);
                            border: 1px solid #286df7;
                            color: #286df7;
                        }
                    }
                }
            }

            .period-value {
                .isShowCgzqText {
                    font-size: 12px;
                    color: #f00;
                }
                ::v-deep {
                    .van-cell {
                        margin-top: 8px;
                        padding: 0;
                        &::after {
                            border: none;
                        }
                    }

                    .van-field__control {
                        height: 32px;
                        border-radius: 6px;
                        padding: 6px 12px;
                        background: #f7f7fc;
                        &::placeholder {
                            text-align: center;
                        }
                    }
                }
            }

            .date-time {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                p {
                    &:nth-child(1),
                    &:nth-child(3) {
                        height: 32px;
                        border-radius: 6px;
                        border: 1px solid #e5e5e5;
                        padding: 6px;
                        width: 100%;
                        font-size: 14px;
                        color: #999;
                        text-align: center;
                    }

                    &:nth-child(2) {
                        font-size: 14px;
                        color: #999;
                        padding: 0 10px;
                    }
                }
            }

            .second-level {
                color: #000;
                font-size: 14px;
                margin-top: 20px;
            }
        }
    }

    .bottom-pd {
        // position: absolute;
        position: fixed;
        bottom: 34px;
        left: 0px;
        width: 100%;
        padding: 0 16px;
        z-index: 2000;

        .bottom-btn {
            border-radius: 20px;
            background: #0e0c0d;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            z-index: 9;

            .left {
                font-size: 16px;
                color: #fff;
                display: flex;
                align-items: center;
                padding: 8px 0 8px 23px;

                .num {
                    font-size: 14px;
                    width: 24px;
                    height: 24px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    background: #3b85fe;
                    margin-left: 8px;
                }
            }

            ::v-deep {
                .r-btn {
                    font-size: 16px;
                    color: #fff;
                    background: #286df7;
                    padding: 0px 16px;
                    border-radius: 0 20px 20px 0;
                    height: 40px;
                    border: none;
                }
            }
        }

        .setup-ing {
            height: 40px;
            border-radius: 20px;
            background: #0e0c0d;
            width: 100%;
            font-size: 14px;
            color: #fff;
        }
    }

    .dpfkmbsm {
        padding: 20px 15px 0;
        height: 343px;
        overflow-y: auto;

        .title {
            font-size: 16px;
            font-weight: 600;
            text-align: center;
        }
        h2 {
            font-size: 13px;
            margin: 5px 0;
        }

        li {
            font-size: 12px;
        }
    }
    .gotit {
        padding: 15px;
        ::v-deep {
            .van-button {
                width: 100%;
                height: 36px;
                border-radius: 6px;
            }
        }
    }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
    .content {
        .condition-list {
            border-bottom: 1px solid #24242f !important;

            .label {
                color: #e4e9fe !important;
            }

            .ji {
                color: #6b7687;
            }

            .van-cell {
                background: none !important;

                &::after {
                    border: none;
                }
            }

            .text {
                color: #aab9d1;
            }

            ::v-deep {
                .van-radio__label {
                    color: #aab9d1;
                }
                .van-field__control,
                .imitation-select,
                .mrsj-button {
                    border: 1px solid #46484f !important;
                    color: #e4e9fe !important;
                    background: none !important;
                }
            }

            .unit {
                background: #191a24 !important;
                color: #6b7687;
            }
        }

        .fk_title {
            color: #e4e9fe !important;
        }

        .period-value {
            .van-cell {
                border: 1px solid #46484f !important;

                background: none !important;
                border-radius: 0.16rem;

                ::v-deep {
                    .van-field__control {
                        color: #e4e9fe !important;
                        background: none !important;
                    }
                }
            }
        }

        .second-level {
            color: #e4e9fe !important;
        }

        .yz-list {
            .h2 {
                color: #e4e9fe;
            }
        }

        .yz-ul {
            background: rgba(255, 255, 255, 0.15) !important;

            li {
                background: rgb(30, 31, 45) !important;
                border: 1px solid rgb(30, 31, 45) !important;

                .a-left,
                .a-right .zhi {
                    color: #e4e9fe !important;
                }

                .a-right {
                    p {
                        color: #aab9d1;
                    }
                }
            }
        }

        .condition {
            background: #191a24;

            .h2 {
                color: #e4e9fe;
            }

            .period {
                border-bottom: 1px solid #2f3548;

                ::v-deep {
                    .van-col {
                        div {
                            border: 1px solid #2f3548;
                            background: #2f3548;
                            color: #e4e9fe !important;
                        }

                        .active {
                            background: rgba(59, 133, 254, 0.2);
                        }
                    }
                }
            }

            .date-time {
                p {
                    color: #e4e9fe !important;
                    background: #191a24 !important;

                    &:first-child,
                    &:last-child {
                        border: 1px solid rgba(255, 255, 255, 0.1);
                    }
                }
            }

            .van-popup {
                background: #1e1f2d;
            }
        }
    }

    .bottom-btn {
        background: #2e3548 !important;
    }

    .setup-ing {
        background: #2e3548 !important;
        border: none;
    }

    .dpfkmbsm {
        background: #1b2135;
        .title,
        h2 {
            color: #e4e9fe;
        }
        li {
            color: #aab9d1;
        }
    }

    .gotit {
        background: #1b2135;
    }
}
</style>
